export default __webpack_public_path__ + "./assets/UT-User_Research_low.mp4";